import { schema } from 'normalizr';
import { LocalizableString } from '../common/types';
import { mapLocalizable } from '../common/utils';

export const eventEntity = new schema.Entity('events', {}, {
  processStrategy(entity) {
    return mapLocalizable(entity);
  },
});

export interface BoothTier {
  id: string;
  name: LocalizableString;
  nameVisible: boolean;
  scale: {
    dimension: number;
    unit: string;
  };
}

export interface CMSEvent {
  id: string;
  locales: string[];
  defaultLocale: string;
  features?: Array<string>;
  boothTiers: BoothTier[];
  createdAt: string;
}
